import { BehaviorSubject } from "rxjs";
import { TransformationNodeDTO } from "../DTO/transformationNodeDTO";
import { TransformationProtocol } from "./transformationProtocol";

export class TransformationNode {
    name!: string;
    type!: number; //element=1,attribute=2,field=3,calculated attribute=4
    alwaysArray!: boolean;
    fileType!: string; //xml or json
    isRoot:boolean=false;
    protocolIndex!: number;
    protocol!: TransformationProtocol;
    parentNode!: TransformationNode;
    childNodes: TransformationNode[] = [];
    children:BehaviorSubject<TransformationNode[]> = new BehaviorSubject<TransformationNode[]>(this.childNodes);
    editMode!: boolean;
    function!: string; //Xpath style function
    functionResultFormat!: string;


    public static mapFromDTO(param:TransformationNodeDTO):TransformationNode{ 
      if (!param) throw new Error("parameter is null")
      let obj = new TransformationNode();
      try
      {
          obj.name = param.name;
          obj.type = param.type;
          obj.alwaysArray = param.alwaysArray;
          obj.protocolIndex = param.protocolIndex;
          if(param.childNodes) {
            let cn = param.childNodes.map(tn=>TransformationNode.mapFromDTO(tn));
            obj.addChildren(cn); //use method to add to trigger behavior subject
          }
          obj.function = param.function;
          obj.functionResultFormat = param.functionResultFormat;
      }
      catch(e)
      {
          console.log(e);
      }
      return obj;
    }

    public static mapToDTO(param:TransformationNode):TransformationNodeDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new TransformationNodeDTO();
        try
        {
          dto.name = param.name;
          dto.type = param.type;
          dto.alwaysArray = param.alwaysArray;
          if(param.protocol) dto.protocolIndex = param.protocol.outputFieldIndex;
          if(param.childNodes) dto.childNodes = param.childNodes.map(tn=>TransformationNode.mapToDTO(tn));
          dto.function = param.function;
          dto.functionResultFormat = param.functionResultFormat;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    
    addChild(node:TransformationNode):void {
      node.parentNode=this;
      this.childNodes.push(node);
      this.childNodes.sort((a,b)=>a.sortOrder-b.sortOrder);
      this.children.next(this.childNodes);
    }
    addChildren(nodes:TransformationNode[]) {
      nodes.forEach(node=>{
        node.parentNode=this;
        this.childNodes.push(node);
      });
      this.childNodes.sort((a,b)=>a.sortOrder-b.sortOrder);
      this.children.next(this.childNodes);
    }
    removeChild(node:TransformationNode):void{
      let index = this.childNodes.indexOf(node);
      if(index>-1) this.childNodes.splice(index,1);
      this.children.next(this.childNodes);
    }
    get canAddElement(){
      return this.type==1;
    }
    get canAddField(){
      return this.fileType=="xml" && this.type==1 && this.childNodes.findIndex(k=>k.type==3)==-1;
    }
    get canAddAttribute(){
      return this.type==1;
    }
    get canRemove(){
      return this.parentNode!=undefined;
    }
    get displayType(){
      switch (this.type){
        case 1:
          return '';
        case 2:
          return '(A)';
        case 3:
          return '(F)';
        case 4:
          return '(CA)';
        default:
          return '';
      }
    }
    get sortOrder(){
      switch (this.type){
        case 1:
          return 4;
        case 2:
          return 1;
        case 3:
          return 3;
        case 4:
          return 2;
        default:
          return 0;
      }
    }
    get clone(){
      //cloning a node means i also have to clone the transformation protocol related to it
      let cloneNode =  new TransformationNode();
      Object.assign(cloneNode, this);
      if(cloneNode.protocol) {
        cloneNode.protocol=cloneNode.protocol.clone;
        cloneNode.protocol.transformationNode=cloneNode;
      }
      cloneNode.childNodes=this.childNodes.map(n=>{let cloneChild=n.clone; cloneChild.parentNode=cloneNode; return cloneChild;});
      cloneNode.children.next(cloneNode.childNodes);
      return cloneNode;
    }
    public flatProtocolArray(protocolArray:TransformationProtocol[]){
      //pushes all protocols from this node and all its childnodes in given array
      if(this.protocol) protocolArray.push(this.protocol);
      this.childNodes.forEach(cn=>cn.flatProtocolArray(protocolArray));
    }

    getChildNodePaths(rootPath:string,flatPathArray:string[], includeRootAttributes:boolean, elementsOnly:boolean){
      this.childNodes.forEach(cn=>{
        if(cn.type==1) flatPathArray.push(rootPath+cn.name);
        else if(cn.type==2 && !elementsOnly && includeRootAttributes){
          flatPathArray.push(rootPath+"@"+cn.name);
        }
        if(cn.type==1){
          cn.getChildNodePaths(rootPath+cn.name+"/",flatPathArray,true,elementsOnly);
        }
      });
    }

    public childNameIsUnique(node:TransformationNode, value:string){
      return this.childNodes.findIndex(n=>n!=node && n.type==node.type && n.name==value)==-1;
    }
}